module.exports = __webpack_public_path__ + "img/logo PWr biale poziom  bez tla.3d8bd6ba.png";